import React from 'react';

class Dropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = { open: false };
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    window.addEventListener('click', this.handleClick, true);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.handleClick);
  }

  handleClick(e) {
    if (this.state.open) {
      if (this.contentRef && this.contentRef.contains(e.target)) return;
      if (window.innerWidth < 768) e.preventDefault();
      this.setState({ open: false });
    } else if (this.triggerRef && this.triggerRef.contains(e.target)) {
      this.setState({ open: true });
    }
  }

  toggleState() {
    this.setState(state => ({
      ...state,
      open: !state.open
    }));
  }

  render() {
    return (
      <div className={this.props.className}>
        {this.props.children({
          isOpen: this.state.open,
          triggerRef: el => (this.triggerRef = el),
          contentRef: el => (this.contentRef = el),
          forceClose: () => this.setState({ open: false })
        })}
      </div>
    );
  }
}

export default Dropdown;



// WEBPACK FOOTER //
// ./shared/components/ui/dropdown/index.js